import React, {useState, useContext, useEffect } from 'react';
import {
  FaUserTie,
  FaStore,
  FaBriefcase,
  FaTags,
  FaMapMarkedAlt,
  FaCity,
  FaDrawPolygon,
  FaUserShield,
  FaShoppingCart,
  FaSpinner,
  FaMapSigns,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "react-datepicker/dist/react-datepicker.css";
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
 import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeContext } from "../../../context/ThemeContext.js";
import { Card, Form } from "react-bootstrap";

import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";

// default = today's date (DD-MM-YYYY)

const COLORS = ["#0088FE", "#0de7bf", "#FFBB28", "#FF8042", "#9c27b0", "#e91e63"];
const VeeAdminDashboard = () => {
  const { changeBackground } = useContext(ThemeContext);
    const [totalbusiness, setTotalbusiness] = useState('');
    const [totaldistricts, setTotaldistricts] = useState('');
    const [totalcity, setTotalcity] = useState('');
    const [totalarea, setTotalarea] = useState('');
    const [totalzone, setTotalzone] = useState('');
    // const [totalcityadminuser, setTotalcityadminuser] = useState('');
    const [cityAdminData, setCityAdminData] = useState({ total_users: 0});
    // From Date - To Date
    const [totalvendor, setTotalvendor] = useState('');
    const [totalshop, setTotalshop] = useState('');
const [startDatetime, setStartDatetime] = useState('');
const [endDatetime, setEndDatetime] = useState('');
  const [projectionData, setProjectionData] = useState([]);
  const [loading, setLoading] = useState(true);
const [businessDate, setBusinessDate] = useState(dayjs().format("DD-MM-YYYY"));




   const fetchtotalbusiness = async () => {
      try {
        const res = await axios.get(`${var_api}sa_business_master/total-businesses`);
        setTotalbusiness(res.data.total_businesses);
      } catch (err) {
        console.error("Failed to fetch business data", err);
      }
    };
   const fetchtotaldistricts = async () => {
      try {
        const res = await axios.get(`${var_api}sa_district_master/total-districts`);
        setTotaldistricts(res.data.total_districts);
      } catch (err) {
        console.error("Failed to fetch district data", err);
      }
    };
   const fetchtotalcity = async () => {
      try {
        const res = await axios.get(`${var_api}sa_city_master/total-cities`);
        setTotalcity(res.data.total_cities);
      } catch (err) {
        console.error("Failed to fetch city data", err);
      }
    };
    const fetchtotalarea = async () => {
      try {
        const res = await axios.get(`${var_api}sa_area_master/total-areas`);
        setTotalarea(res.data.total_areas);
      } catch (err) {
        console.error("Failed to fetch area data", err);
      }
    };
    const fetchtotalzone = async () => {
      try {
        const res = await axios.get(`${var_api}sa_zone_master/total-zones`);
        setTotalzone(res.data.total_zones);
      } catch (err) {
        console.error("Failed to fetch zone data", err);
      }
    };
    // const fetchtotalcityadminuser = async () => {
    //   try {
    //     const res = await axios.get(`${var_api}sa_city_admin_user/total-users`);
    //     setTotalcityadminuser(res.data.total_cityadminusers);
    //   } catch (err) {
    //     console.error("Failed to fetch cityadminuser data", err);
    //   }
    // };
    const fetchCityAdminData = async () => {
      try {
        const res = await axios.get(`${var_api}sa_city_admin_user/total-users`);
        setCityAdminData(res.data); // { total_users: 1, active_users: 1 }
      } catch (err) {
        console.error("Failed to fetch city admin data", err);
      }
    };
    //From Date - To Date 
    const fetchtotalvendor = async (start, end) => {
      try {
        const res = await axios.post(`${var_api}ci_vendors/vendors-by-datetime`, {
          start_datetime: start,
          end_datetime: end
        });
        const shopCount = res.data.length;
        setTotalvendor(shopCount);
      } catch (err) {
        console.error("Failed to fetch vendor data", err);
      }
    };
    const fetchtotalshop = async (start, end) => {
      try {
        const res = await axios.post(`${var_api}ci_shop/shops-by-datetime`, {
          start_datetime: start,
          end_datetime: end
        });
        const shopCount = res.data.length;
        setTotalshop(shopCount);
      } catch (err) {
        console.error("Failed to fetch shop data", err);
      }
    };

 const fetchProjectionData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${var_api}detail-list/get-all-detail`);
      if (res.data) {
        setProjectionData(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch projection data", error);
    } finally {
      setLoading(false);
    }
  };
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF", "#FF4D4D", "#FF9933", "#66CCFF", "#339966"];

  const [closingData, setClosingData] = useState([]);

  const fetchClosingData = async (date) => {
    try {
      const res = await axios.post(`${var_api}sa_day_closing/getbybusinessdate`, {
        business_date: dayjs(date).format("DD-MM-YYYY"), // API expects DD-MM-YYYY
      });

      const data = res.data?.data || [];
      if (data.length > 0) {
        const record = data[0];

        const pieData = [
          { name: "Service Profit", value: Math.abs(Number(record.service_profit) || 0) },
          { name: "Handling Profit", value: Math.abs(Number(record.handling_profit) || 0) },
          { name: "Platform Fee Profit", value: Math.abs(Number(record.platform_fee_profit) || 0) },
          { name: "Small Cart Fee Profit", value: Math.abs(Number(record.small_cartfee_profit) || 0) },
          { name: "Delivery Expenses", value: Math.abs(Number(record.deliver_expenses) || 0) },
          { name: "Delivery Welfare", value: Math.abs(Number(record.deliver_welfare) || 0) },
          { name: "Total Earnings", value: Math.abs(Number(record.total_earnings) || 0) },
          { name: "Total Expense", value: Math.abs(Number(record.total_expense) || 0) },
          { name: "Net Profit", value: Math.abs(Number(record.net_profit) || 0) },
        ];

        setClosingData(pieData);
      } else {
        setClosingData([]);
      }
    } catch (error) {
      console.error("Error fetching day closing data:", error);
    }
  };



// if you ever want to change it manually (later)
const handleDateChange = (date) => {
  const formattedDate = dayjs(date).format("DD-MM-YYYY");
  setBusinessDate(formattedDate);
};



 useEffect(() => {
  changeBackground({ value: "light", label: "Light" });
  fetchtotalbusiness();
  fetchtotaldistricts();
  fetchtotalcity();
  fetchtotalarea();
  fetchtotalzone();
  // fetchtotalcityadminuser();
  fetchCityAdminData();
  // From Date - To Date
  fetchtotalvendor();
  fetchtotalshop();
  fetchProjectionData();

    if (businessDate) {
      fetchClosingData(businessDate);
    }
  }, [businessDate]);

  const pieData = projectionData.map((item) => ({
    name: item.sa_general_expense_name_master || "N/A",
    value: Number(item.projection_amount || 0) / 30, // day view
  }));

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="row">

                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaBriefcase size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">{totalbusiness}</h2>
                          <p className="mb-0 text-nowrap">Business</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaTags size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">200</h2>
                          <p className="mb-0 text-nowrap">Products</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaMapMarkedAlt size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">{totaldistricts}</h2>
                          <p className="mb-0">Total Variants</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaCity size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">{totalcity}</h2>
                          <p className="mb-0">Total City</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 

                {/* <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaUserShield size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">{totalarea}</h2>
                          <p className="mb-0">Total Area</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  */}

                {/* <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaMapSigns size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">{totalzone}</h2>
                          <p className="mb-0">Total Zone</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  */}
                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaDrawPolygon size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          {/* <h2 className="mb-0 font-w600">{totalcityadminuser || 0}</h2> */}
                          <h2 className="mb-0 font-w600">{cityAdminData.total_users}</h2>
                          <p className="mb-0">Total  Warehouse User</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 

                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaUserTie size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">51</h2>
                          <p className="mb-0">Total Warehouse</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
                
                <div className="col-xl-3 col-sm-6">
                  <div className="card booking">
                    <div className="card-body">
                      <div className="booking-status d-flex align-items-center">
                        <span><FaStore size={28} color="var(--primary)" /></span>
                        <div className="ms-4">
                          <h2 className="mb-0 font-w600">16</h2>
                          <p className="mb-0">Total Shops</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 

              </div>
            </div>

          
</div>




       
          </div>
        </div>
        
    </>
  );
};

export default VeeAdminDashboard;
